import { VideoM3u8 } from './VideoM3u8';

export type { TypeVideoM3u8Props } from './types';
export default VideoM3u8;
